import { render, staticRenderFns } from "./payContent.vue?vue&type=template&id=1be5936a&scoped=true&"
import script from "./payContent.vue?vue&type=script&lang=js&"
export * from "./payContent.vue?vue&type=script&lang=js&"
import style0 from "./payContent.vue?vue&type=style&index=0&id=1be5936a&lang=scss&scoped=true&"
import style1 from "./payContent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be5936a",
  null
  
)

export default component.exports